<div
  class="pt-4 flex flex-col gap-y-4 h-full"
  id="toolbar"
  *transloco="let fieldTranslation; read: 'field-types'"
>
  <!-- Fixed demo sidebar -->
  <div class="text-3xl font-bold tracking-tighter px-4">Tipos de campos</div>

  <div class="flex flex-col h-full px-4 pt-2 pb-4 overflow-y-auto">
    <div
      *ngFor="let item of fieldTypes"
      class="flex flex-row mb-3 px-2 py-3 ring-1 ring-gray-200 rounded-sm shadow bg-gray-50 cursor-pointer"
      cdkDrag
      (cdkDragStarted)="onDragStarted()"
      (cdkDragEnded)="onDragEnded()"
      [cdkDragData]="item"
    >
      <mat-icon [svgIcon]="item.icon"></mat-icon>
      <div class="flex flex-auto px-2 w-full items-center content-center">
        <span>{{ fieldTranslation(item.id) }}</span>
      </div>

      <div
        *cdkDragPlaceholder
        class="w-76 flex flex-row px-2 py-3 ring-1 ring-gray-200 rounded-sm bg-gray-50 shadow mb-3"
      >
            <mat-icon [svgIcon]="item.icon"></mat-icon>
            <div class="flex flex-auto px-2 w-full items-center content-center">
                <span>{{ fieldTranslation(item.id) }}</span>
            </div>
      </div>

      <div
        *cdkDragPreview
        class="w-72 flex flex-row px-2 py-3 ring-1 ring-gray-200 rounded-sm shadow bg-gray-50"
      >
        <mat-icon [svgIcon]="item.icon"></mat-icon>
        <div class="flex flex-auto px-2 w-full items-center content-center">
          <span>{{ fieldTranslation(item.id) }}</span>
        </div>
      </div>
    </div>
  </div>
</div>
